export class WebSocketClient {
  static instance = null;

  static getInstance(url, options = {}) {
    if (!WebSocketClient.instance) {
      WebSocketClient.instance = new WebSocketClient(url, options);
    }
    return WebSocketClient.instance;
  }

  constructor(url, options = {}) {
    // 防止直接 new
    if (WebSocketClient.instance) {
      return WebSocketClient.instance;
    }

    this.url = url;
    this.options = {
      reconnect: true,
      reconnectInterval: 3000,
      maxReconnectAttempts: 10,
      ...options
    };
    
    this.ws = null;
    this.reconnectAttempts = 0;
    this.reconnectTimer = null;
    this.isConnecting = false;
    WebSocketClient.instance = this;
    this.connect();
  }

  connect() {
    if (this.isConnecting || (this.ws?.readyState === WebSocket.CONNECTING)) {
      console.log('WebSocket is already connecting');
      return;
    }
    
    if (this.ws?.readyState === WebSocket.OPEN) {
      console.log('WebSocket is already connected');
      return;
    }

    try {
      this.isConnecting = true;
      this.ws = new WebSocket(this.url);
      
      this.ws.onopen = () => {
        this.isConnecting = false;
        this.options.onOpen?.();
        this.reconnectAttempts = 0;
      };

      this.ws.onclose = () => {
        this.isConnecting = false;
        this.options.onClose?.();
        
        if (this.options.reconnect && 
            this.reconnectAttempts < this.options.maxReconnectAttempts && 
            !this.ws._closedManually) {
          this.reconnectTimer = setTimeout(() => {
            this.reconnectAttempts++;
            this.options.onReconnecting?.();
            this.connect();
          }, this.options.reconnectInterval);
        }
      };

      this.ws.onmessage = (event) => {
        // 触发所有注册的消息回调
        this.options.onMessage?.(event)
      };

      this.ws.onerror = (error) => {
        this.options.onError?.(error);
      };

    } catch (error) {
      this.isConnecting = false;
      console.error('WebSocket connection error:', error);
    }
  }

  send(data) {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(typeof data === 'string' ? data : JSON.stringify(data));
    }
  }

  close() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }
    if (this.ws) {
      this.ws._closedManually = true;
      this.ws.close();
    }
  }

  // 销毁单例
  static destroy() {
    if (WebSocketClient.instance) {
      WebSocketClient.instance.close();
      WebSocketClient.instance = null;
    }
  }
} 